import { Link } from "react-router-dom";
import { categories } from "@/mocks/archive";

export default function CategoryGrid() {
  return (
    <section className="w-full px-4 md:px-8 py-14 md:py-20 bg-background-100">
      <div className="flex flex-col md:flex-row md:items-end justify-between gap-4 mb-8 md:mb-10">
        <div>
          <span className="text-xs tracking-[0.22em] text-primary-600">ARCHIVE SECTIONS</span>
          <h2 className="mt-2 font-heading text-2xl md:text-3xl font-bold text-foreground-950">
            六类档案，各管一段旧料
          </h2>
        </div>
        <p className="max-w-md text-sm text-foreground-600 leading-relaxed">
          不同性质的材料分开归档，避免把早期玩笑、公开处理结果和未经确认的猜测混作一谈。
        </p>
      </div>

      <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4 md:gap-5">
        {categories.map((cat) => (
          <Link
            key={cat.slug}
            to="/archive"
            className="group flex flex-col p-5 md:p-6 rounded-lg bg-background-50 border border-background-300 hover:border-primary-300 hover:bg-background-50/60 transition-colors"
          >
            <div className="flex items-start justify-between mb-4">
              <span className="w-11 h-11 flex items-center justify-center rounded-md bg-accent-100 text-accent-800 text-xl">
                <i className={cat.icon}></i>
              </span>
              <span className="text-[11px] text-foreground-500 border border-background-300 rounded-md px-2 py-0.5">
                {cat.count} 篇
              </span>
            </div>
            <h3 className="font-heading text-lg font-semibold text-foreground-950 mb-2">
              {cat.name}
            </h3>
            <p className="text-sm text-foreground-600 leading-relaxed flex-1">{cat.desc}</p>
            <span className="mt-4 inline-flex items-center gap-1 text-xs text-primary-600">
              查看该类档案
              <i className="ri-arrow-right-line group-hover:translate-x-1 transition-transform"></i>
            </span>
          </Link>
        ))}
      </div>
    </section>
  );
}